// extracted by mini-css-extract-plugin
export default {"rootCotainer":"CandidateQuestions_rootCotainer__fLA6p","header":"CandidateQuestions_header__HTX41"};